import React from "react";
import styled from "styled-components";
import TermlyEmbed from "../components/TermlyEmbed";

const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  margin-top: 64px;
  padding: 0 24px 64px;
  max-width: 1080px;
  min-height: calc(100vh - 444px);

  color: var(--body-text);

  a {
    color: var(--brand-pink);
  }
`;

function TermsAndConditions() {
  return (
    <Container>
      <TermlyEmbed dataId="967e50bf-5e5b-43d6-a979-fa49ae092852" />
    </Container>
  );
}

export default TermsAndConditions;
